import { RefreshCw } from 'lucide-react';
import { useUpdates } from '../lib/updates.tsx';

/* La bande qui annonce une nouvelle version.
 *
 * Rendue au niveau de l'application, et non dans la coquille authentifiée :
 * celle-ci n'existe pas sur l'écran de connexion, où une version périmée est
 * pourtant tout aussi gênante — c'est même là qu'on atterrit après une longue
 * absence. Placée dans la coquille, la bande était invisible précisément dans
 * le cas où elle sert le plus.
 *
 * En bas de l'écran : le haut porte déjà le titre et la pastille d'invitation,
 * et une bande de plus y repousserait le contenu. En bas, elle est sous le
 * pouce, là où on l'atteint sans se replacer.
 *
 * `md:pl-72` reprend le décalage du tiroir permanent sur grand écran, sans
 * lequel la bande passerait dessous.
 */
export function UpdateBanner() {
    const { ready, apply } = useUpdates();
    if (!ready) return null;

    return (
        <div
            role="status"
            className="fixed inset-x-0 bottom-0 z-40 border-t border-primary/40 bg-base-200/95 px-4 py-3 backdrop-blur md:pl-72"
        >
            <div className="mx-auto flex max-w-3xl items-center gap-3">
                <RefreshCw size={20} className="shrink-0 text-primary" />
                <span className="min-w-0 flex-1 text-sm">
                    <span className="block font-semibold">Nouvelle version disponible</span>
                    <span className="block text-xs opacity-60">L'application se rechargera.</span>
                </span>
                <button type="button" onClick={apply} className="btn btn-primary btn-sm shrink-0">
                    Mettre à jour
                </button>
            </div>
        </div>
    );
}
